import React from 'react';
import { ScrollView } from 'react-native';
import { View } from 'modules/styled';
import ToggleContainer from 'modules/profile/settings/toggle.container';

const Settings = () => (
  <ScrollView>
    <View sx={{ p: 2, bg: 'white' }}>
      <ToggleContainer />
    </View>
  </ScrollView>
);

export default Settings;
